<template>
  <div class="xpress-user-onboarding">
    <!-- loading spinner -->
    <n-modal v-model:show="loading">
      <page-spinner :onloader="'flex'" />
    </n-modal>
    <!-- ------------------------ -->
    <section>
      <!-- logo -->
      <div class="xpress-logo-box">
        <router-link to="/home">
          <img :src="appLogo" alt="xpress payment logo">
        </router-link>
      </div>

      <div class="xpress-user-auth-form">
        <!-- response message -->
        <p
          :class="[
            newUserEmailValidation.responseModalDialogueOptions.actionStatus === 'success'
              ? 'text-success' : 'text-error',
              'text-center'
          ]"
        >{{newUserEmailValidation.responseModalDialogueOptions.actionMessage}}</p>
      </div>
    </section>
  </div>

  <!-- response modal -->
  <n-modal
    v-model:show="newUserEmailValidation.responseModalDialogueOptions.show"
    :mask-closable="true"
    :closable="false"
    :show-icon="false"
    preset="dialog"
    :positive-text="newUserEmailValidation.responseModalDialogueOptions.positiveText"
    :negative-text="newUserEmailValidation.responseModalDialogueOptions.negativeText"
    @positive-click="newUserEmailValidation.takeAction"
    @negative-click="newUserEmailValidation.takeAction"
  >
    <span :class="[
      newUserEmailValidation.responseModalDialogueOptions.actionStatus==='success'?'text-success':'text-danger'
    ]">
      {{newUserEmailValidation.responseModalDialogueOptions.actionMessage}}
    </span>
  </n-modal>
</template>

<script>
import { computed, reactive, ref } from '@vue/reactivity'
import { useStore } from 'vuex'

import { useRoute, useRouter } from 'vue-router'
import { onBeforeMount } from '@vue/runtime-core'

import { NModal } from 'naive-ui'

import { ValidateEmail } from '@/mixins/use-users'

import PageSpinner from '@/components/PageSpinner.vue'

import 'bootstrap/dist/css/bootstrap.min.css'

export default {
  name: 'Validate Email',
  components: {
    NModal,
    PageSpinner
  },
  setup () {
    const store = useStore()
    const query = useRoute().query
    const router = useRouter()

    const appLogo = ref(require('@/assets/logo.png'))

    const loading = computed(() => store.getters._globalLoading)

    const hasValidEmailValidationUrl = ref(false)

    const model = reactive({})

    class NewUserEmailValidation {
      constructor () {
        // response modal
        this.responseModalDialogueOptions = reactive({
          show: false,
          positiveText: '',
          negativeText: '',
          actionStatus: computed(() => store.getters._actionStatus),
          actionMessage: computed(() => store.getters._actionMessage)
        })
      }

      takeAction = () => {
        // check if token is valid, so as to proceed to login
        if (hasValidEmailValidationUrl.value) {
        //   route user user to login page
          store.dispatch('users/UserLogin')
        } else {
          // token is in valid
        }
      }

      validateUrlToken = async () => {
        // start spinner
        store.commit('LOADING', true)

        await ValidateEmail(query?.token)
          .then(response => {
            // valid email url
            if ([0, '0', '00'].includes(response?.responseCode)) {
              hasValidEmailValidationUrl.value = true

              setTimeout(() => {
                // stop spinner
                store.commit('LOADING', false)

                // update modal button text
                this.responseModalDialogueOptions.positiveText = 'Proceed to Login'
                this.responseModalDialogueOptions.negativeText = ''

                // show response modal
                this.responseModalDialogueOptions.show = true
              }, 2000)
            } else
            // merchant email has been activated
            if (response.responseCode === '03' || response.responseCode === 3) {
              // check response message

              // invalid token
              if (response.responseMessage.toLowerCase() === 'invalid token') {
                hasValidEmailValidationUrl.value = false

                setTimeout(() => {
                  // stop spinner
                  store.commit('LOADING', false)

                  // update modal button text
                  this.responseModalDialogueOptions.positiveText = ''
                  this.responseModalDialogueOptions.negativeText = 'Close'

                  // show response modal
                  this.responseModalDialogueOptions.show = true
                }, 2000)
              } else {
                // validated token
                hasValidEmailValidationUrl.value = true

                setTimeout(() => {
                  // stop spinner
                  store.commit('LOADING', false)

                  // update modal button text
                  this.responseModalDialogueOptions.positiveText = 'Proceed to Login'
                  this.responseModalDialogueOptions.negativeText = ''

                  // show response modal
                  this.responseModalDialogueOptions.show = true
                }, 2000)
              }
            } else {
              hasValidEmailValidationUrl.value = false

              setTimeout(() => {
                // stop spinner
                store.commit('LOADING', false)

                // update modal button text
                this.responseModalDialogueOptions.positiveText = ''
                this.responseModalDialogueOptions.negativeText = 'Close'

                // show response modal
                this.responseModalDialogueOptions.show = true
              }, 2000)
            }
          })
          .catch(() => {
            setTimeout(() => {
              // stop spinner
              store.commit('LOADING', false)

              // update modal button text
              this.responseModalDialogueOptions.positiveText = ''
              this.responseModalDialogueOptions.negativeText = 'Close'

              // show response modal
              this.responseModalDialogueOptions.show = true
            }, 2000)
          })
      }

      submitForm = async () => {}
    }
    const newUserEmailValidation = new NewUserEmailValidation()

    onBeforeMount(() => {
      // redirect to not found if no query is found in current route
      if (!query.token) router.push('/not-found')
      else newUserEmailValidation.validateUrlToken()
    })

    return {
      appLogo,
      loading,
      hasValidEmailValidationUrl,
      model,
      newUserEmailValidation
    }
  }
}
</script>
